import { render, staticRenderFns } from "./PlatformServices.vue?vue&type=template&id=14634828&scoped=true&"
import script from "./PlatformServices.vue?vue&type=script&lang=js&"
export * from "./PlatformServices.vue?vue&type=script&lang=js&"
import style0 from "./PlatformServices.vue?vue&type=style&index=0&id=14634828&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14634828",
  null
  
)

export default component.exports